<template>
    <div id="export-view">
        <LoadingDots v-if="isLoading" />
        <div class="export-menu" v-if="!isLoading && settings.mod_export_enable === '1'">
            <div class="logo"><img src="@/assets/logo.png" /></div>
            <div class="config">
                <ConfigLink icon="file-export" link="/export">Export</ConfigLink>
            </div>
            <MenuLink></MenuLink>
        </div>
        <div class="export-content" v-if="!isLoading && settings.mod_export_enable === '1'">
            <!-- Header -->
            <div class="filter-view">
                <div class="export-title">Exporter les données (Linux uniquement)</div>
            </div>
            <LoadingDots v-if="isLoading" />

            <!-- Exports enregistrés -->
            <div class="export-body" v-if="!isLoading">
                <div class="export-section">
                    <h3 class="section--title">Exports enregistrés</h3>

                    <!-- Nom de l'export -->
                    <div class="form-control">
                        <label>Nom de l'export</label>
                        <Select
                            class="stretch filter selection--item sm-field"
                            placeholder
                            :options="savedExportsList"
                            :multiple="false"
                            :search="false"
                            :limit="100000"
                            v-model="formValues.savedExport"
                        />
                    </div>

                    <div class="form-control">
                        <!-- Bouton chargement export -->
                        <button
                            type="button"
                            class="default osm-button warning"
                            @click="loadExport"
                        >
                            Charger l'export
                        </button>

                        <!-- Bouton suppression export -->
                        <button
                            type="button"
                            class="default osm-button danger"
                            @click="removeExport"
                        >
                            Supprimer l'export
                        </button>
                    </div>
                </div>
            </div>

            <form class="export-form">
                <!-- Paramètres de l'export -->
                <div class="export-body" v-if="!isLoading">
                    <div class="export-section">
                        <!-- Titre -->
                        <h3 class="section--title">Paramètres de l'export</h3>

                        <!-- Groupes d'objets -->
                        <div class="form-control">
                            <label>Groupe d'objets</label>
                            <Select
                                class="stretch filter selection--item sm-field"
                                placeholder="Sélectionner un groupe d'objets"
                                :options="objectGroupsList"
                                :multiple="false"
                                :search="false"
                                :limit="100000"
                                v-model="formValues.objectGroup"
                            />
                        </div>

                        <!-- Statuts -->
                        <div class="form-control">
                            <label>Statuts</label>
                            <Select
                                class="stretch sm-field filter selection--item"
                                placeholder="Sélectionner les statuts des objets"
                                :options="objectStatusList"
                                :multiple="true"
                                :search="false"
                                :limit="100000"
                                v-model="formValues.objectStatus"
                            />
                        </div>

                        <!-- États -->
                        <div class="form-control">
                            <label>États</label>
                            <Select
                                class="stretch sm-field filter selection--item"
                                placeholder="Sélectionner les états des objets"
                                :options="objectStatesList"
                                :multiple="true"
                                :search="false"
                                :limit="100000"
                                v-model="formValues.objectStates"
                            />
                        </div>

                        <!-- Attributs -->
                        <div class="form-control">
                            <label>Attributs (optionnel)</label>
                            <Select
                                class="stretch sm-field filter selection--item"
                                placeholder="Sélectionner les attributs devant être présents dans les objets"
                                :options="objectTagsList"
                                :multiple="true"
                                :search="true"
                                :limit="100000"
                                v-model="formValues.objectTags"
                            />
                        </div>

                        <!-- Format de sortie -->
                        <div class="form-control">
                            <label
                                >Format de sortie (le format ESRI Shapefile ne gère pas les
                                collections de géométries)</label
                            >
                            <Select
                                class="stretch sm-field filter selection--item"
                                placeholder="Sélectionner un format de sortie"
                                :options="outputFormatsList"
                                :multiple="false"
                                :search="false"
                                :limit="100000"
                                v-model="formValues.outputFormat"
                            />
                        </div>

                        <!-- Nom du fichier de sortie -->
                        <div class="form-control">
                            <label>
                                Nom des fichiers et des couches générés (sans extension)
                                <Input
                                    class="stretch filter selection--item sm-field"
                                    placeholder="Saisir un nom pour les fichiers et les couches de sortie (sans extension)"
                                    v-model="formValues.fileName"
                                />
                            </label>
                        </div>

                        <!-- Date début/fin -->
                        <div class="form-control">
                            <div class="export-date-range sm-field">
                                <div class="export-date-start">
                                    <label>Date de début*</label>
                                    <datepicker
                                        :language="fr"
                                        :monday-first="true"
                                        :typeable="true"
                                        :format="customFormatterStart"
                                        :use-utc="false"
                                        v-model="formValues.startDate"
                                        name="startDate"
                                    ></datepicker>
                                </div>
                                <div class="export-date-end">
                                    <label>Date de fin*</label>
                                    <datepicker
                                        :language="fr"
                                        :monday-first="true"
                                        :typeable="true"
                                        :format="customFormatterEnd"
                                        :use-utc="false"
                                        v-model="formValues.endDate"
                                        name="endDate"
                                    ></datepicker>
                                </div>
                                <p>
                                    * Vous pouvez saisir les dates directement au clavier au format
                                    mm/jj/aaaa (mois jour année), ou cliquer pour afficher le
                                    calendrier.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Enregistrement de l'export -->
                <div class="export-body" v-if="!isLoading">
                    <div class="export-section">
                        <!-- Titre -->
                        <h3 class="section--title">Enregistrement de l'export</h3>

                        <!-- Nom de l'export -->
                        <div class="form-control">
                            <label>
                                Nom de l'export
                                <Input
                                    class="stretch filter selection--item sm-field"
                                    placeholder="Choisir un nom d'export existant pour l'écraser ou saisir un nouveau nom"
                                    v-model="formValues.saveExportName"
                                />
                            </label>
                        </div>

                        <!-- Export Partagé -->
                        <div class="form-control">
                            <label>Export partagé</label>
                            <Select
                                class="stretch filter selection--item sm-field"
                                placeholder="Sélectionner un format de sortie"
                                :options="sharedExportList"
                                :multiple="false"
                                :search="false"
                                :limit="100000"
                                v-model="formValues.sharedExport"
                            />
                        </div>
                    </div>
                </div>

                <!-- Bouton export -->
                <div class="form-control export-button" v-if="!isLoading">
                    <button
                        type="button"
                        class="default stretch osm-button"
                        @click="generateReport"
                    >
                        Exporter
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Select from '@/components/Select';
import Input from '@/components/Input';
import LoadingDots from '@/components/LoadingDots';
import ConfigLink from '@/components/ConfigLink';
import Datepicker from 'vuejs-datepicker';
import { fr } from 'vuejs-datepicker/dist/locale';
import { authenticationService } from '@/services';
import MenuLink from '@/layouts/Menu.vue';
import format from 'date-fns/format';

export default {
    data() {
        return {
            fr,
            isLoading: true,
            formValues: {
                objectGroup: [],
                objectStatus: [],
                objectStates: [],
                objectTags: [],
                outputFormat: { id: 'shapefile', text: 'ESRI Shapefile' },
                fileName: 'result',
                loadExportName: '',
                saveExportName: '',
                sharedExport: { id: false, text: 'Non' },
                startDate: null,
                endDate: null,
                savedExport: {},
            },
            objectGroupsList: [],
            objectStatusList: [],
            objectStatesList: [],
            objectTagsList: [],
            outputFormatsList: [
                { id: 'gpkg', text: 'GeoPackage' },
                { id: 'kml', text: 'KML (Keyhole Markup Language)' },
                { id: 'shapefile', text: 'ESRI Shapefile' },
            ],
            sharedExportList: [{ id: false, text: 'Non' }, { id: true, text: 'Oui' }],
            savedExportsList: [],
            user: authenticationService.currentUserValue,
            settings: {
                mod_export_enable: null,
            },
            loaded_settings: [],
        };
    },
    mounted() {
        // Charge la liste des groupes d'objets
        this.isLoading = true;
        this.loadObjectGroupsList();
        this.loadObjectStatusList();
        this.loadObjectStatesList();
        this.loadObjectTagsList();
        this.loadSavedExportsList();
        this.loadSettings();
    },
    methods: {
        customFormatterStart(date) {
            // Formate la date modifiée à minuit
            return format(date.setUTCHours(0, 0, 0), 'MM/dd/yyyy HH:mm:ss');
        },
        customFormatterEnd(date) {
            // Formate la date modifiée à 23:59:59
            return format(date.setUTCHours(23, 59, 59), 'MM/dd/yyyy HH:mm:ss');
        },
        loadSettings() {
            this.$http
                .get('/api/setting/')
                .then(
                    (response) => {
                        const settings = response.body;
                        this.loaded_settings = settings;
                        settings.forEach((s) => (this.settings[s.name] = s.value));
                    },
                    (response) => {
                        // error callback
                        console.log(JSON.stringify(response));
                    },
                )
                .finally(() => {
                    this.activatedVerif();
                    this.isLoading = false;
                });
        },

        activatedVerif() {
            if (this.settings.mod_export_enable !== '1') {
                this.$router.push({ path: '/home' });
            }
        },

        loadObjectGroupsList() {
            //this.isLoading = true;
            this.$http.get('/api/object-group').then(
                (response) => {
                    // success callback
                    if (response && response.status === 200 && response.body) {
                        this.objectGroupsList = [];
                        for (let i = 0; i < response.body.length; i++) {
                            const elem = response.body[i];
                            if (elem.id && elem.name) {
                                this.objectGroupsList.push({
                                    id: elem.id,
                                    text: elem.name,
                                });
                            } else {
                                console.error('elem not valid', elem);
                            }
                        }
                    } else {
                        console.error('response not valid', response);
                    }
                    //this.isLoading = false;
                },
                (response) => {
                    // error callback
                    console.error(JSON.stringify(response));
                    //this.isLoading = false;
                },
            );
        },
        loadObjectStatusList() {
            //this.isLoading = true;
            this.$http.get('/api/status').then(
                (response) => {
                    // success callback
                    if (response && response.status === 200 && response.body) {
                        this.objectStatusList = [];
                        for (let i = 0; i < response.body.length; i++) {
                            const elem = response.body[i];
                            if (elem.name && elem.desc_fr) {
                                this.objectStatusList.push({
                                    id: elem.id,
                                    text: elem.desc_fr,
                                });
                            } else {
                                console.error('elem not valid', elem);
                            }
                        }
                    } else {
                        console.error('response not valid', response);
                    }
                    //this.isLoading = false;
                },
                (response) => {
                    // error callback
                    console.error(JSON.stringify(response));
                    //this.isLoading = false;
                },
            );
        },
        loadObjectStatesList() {
            //this.isLoading = true;
            this.$http.get('/api/state').then(
                (response) => {
                    // success callback
                    if (response && response.status === 200 && response.body) {
                        this.objectStatesList = [];
                        for (let i = 0; i < response.body.length; i++) {
                            const elem = response.body[i];
                            if (elem.id && elem.desc_fr) {
                                this.objectStatesList.push({
                                    id: elem.id,
                                    text: elem.desc_fr,
                                });
                            } else {
                                console.error('elem not valid', elem);
                            }
                        }
                    } else {
                        console.error('response not valid', response);
                    }
                    //this.isLoading = false;
                },
                (response) => {
                    // error callback
                    console.error(JSON.stringify(response));
                    //this.isLoading = false;
                },
            );
        },
        loadObjectTagsList() {
            //this.isLoading = true;
            this.$http.get('/api/tag').then(
                (response) => {
                    // success callback
                    if (response && response.status === 200 && response.body) {
                        this.objectTagsList = [];
                        for (let i = 0; i < response.body.length; i++) {
                            const elem = response.body[i];
                            if (elem.name) {
                                this.objectTagsList.push({
                                    id: elem.name,
                                    text: elem.name_fr
                                        ? `${elem.name} (${elem.name_fr})`
                                        : elem.name,
                                });
                            } else {
                                console.error('elem not valid', elem);
                            }
                        }
                    } else {
                        console.error('response not valid', response);
                    }
                    //this.isLoading = false;
                },
                (response) => {
                    // error callback
                    console.error(JSON.stringify(response));
                    //this.isLoading = false;
                },
            );
        },
        loadSavedExportsList() {
            //this.isLoading = true;
            this.$http.get('/api/export/saved').then(
                (response) => {
                    // success callback
                    if (response && response.status === 200 && response.body) {
                        this.savedExportsList = [];
                        for (let i = 0; i < response.body.length; i++) {
                            const elem = response.body[i];
                            if (elem.id && elem.name && elem.query) {
                                this.savedExportsList.push({
                                    id: elem.id,
                                    text: elem.name,
                                    query: elem.query,
                                    shared: elem.shared,
                                });
                            } else {
                                console.error('elem not valid', elem);
                            }
                        }
                    } else {
                        console.error('response not valid', response);
                    }
                    //this.isLoading = false;
                },
                (response) => {
                    // error callback
                    console.error(JSON.stringify(response));
                    //this.isLoading = false;
                },
            );
        },
        saveExport() {
            //this.isLoading = true;
            const exportName = this.formValues.saveExportName;
            const sharedExport = this.formValues.sharedExport.id;
            const parsedValues = this.getParsedValues();
            let jsonValues;

            try {
                jsonValues = JSON.stringify(parsedValues);
            } catch (error) {
                console.error('Could not JSON parse values', parsedValues);
            }

            if (parsedValues && exportName.length > 0) {
                const oBody = {
                    name: exportName,
                    query: jsonValues,
                    shared: sharedExport,
                };
                this.$http.post('/api/export/saved', oBody).then(
                    () => {
                        // Recharge la liste des exports
                        this.loadSavedExportsList();
                        //this.isLoading = false;
                    },
                    (response) => {
                        //this.isLoading = false;
                        // Error
                        console.error(response.data);
                    },
                );
            }
        },

        generateReport() {
            this.isLoading = true;
            // Sauvegarde de l'export
            if (this.formValues.saveExportName.length > 0) {
                this.saveExport();
            }

            if (this.formValues) {
                //this.isLoading = true;
                this.$http.post('/api/export/generate', this.getParsedValues()).then(
                    (response) => {
                        // Success
                        if (response.data && response.data.exported_file) {
                            const exportedFilePath = response.data.exported_file.split('/');
                            if (exportedFilePath) {
                                this.downloadExport(exportedFilePath[2], exportedFilePath[3]);
                                this.isLoading = false;
                            }
                        } else {
                            console.error('response not valid', response);
                            this.isLoading = false;
                        }
                        //this.isLoading = false;
                    },
                    (response) => {
                        // Error
                        console.error(response.data);
                        this.isLoading = false;
                    },
                );
            }
        },

        // prépare le contenu de la requête
        getParsedValues() {
            let objectGroup = [];
            let objectStatus = [];
            let objectStates = [];
            let objectTags = [];
            let outputFormat;
            let fileName;
            let startDate;
            let endDate;

            // Remplit objectGroup
            if (this.formValues.objectGroup && this.formValues.objectGroup.id) {
                objectGroup = this.formValues.objectGroup.id;
            }

            // Remplit objectStatus
            if (this.formValues.objectStatus && this.formValues.objectStatus.length) {
                for (let i = 0; i < this.formValues.objectStatus.length; i++) {
                    const objState = this.formValues.objectStatus[i];
                    if (objState.id) {
                        objectStatus.push(objState.id);
                    }
                }
            }

            // Remplit objectStates
            if (this.formValues.objectStates && this.formValues.objectStates.length) {
                for (let i = 0; i < this.formValues.objectStates.length; i++) {
                    const objState = this.formValues.objectStates[i];
                    if (objState.id) {
                        objectStates.push(objState.id);
                    }
                }
            }

            // Remplit objectTags
            if (this.formValues.objectTags && this.formValues.objectTags.length) {
                for (let i = 0; i < this.formValues.objectTags.length; i++) {
                    const objTag = this.formValues.objectTags[i];
                    if (objTag.id) {
                        objectTags.push(objTag.id);
                    }
                }
            }

            // Remplit outputFormat
            if (this.formValues.outputFormat && this.formValues.outputFormat.id) {
                outputFormat = this.formValues.outputFormat.id;
            }

            // Remplit fileName
            if (this.formValues.fileName) {
                fileName = this.formValues.fileName;
            }

            // Remplit startDate
            if (this.formValues.startDate) {
                startDate = Date.parse(this.formValues.startDate);
            }

            // Remplit endDate
            if (this.formValues.endDate) {
                endDate = Date.parse(this.formValues.endDate);
            }

            return {
                objectGroup,
                objectStatus,
                objectStates,
                objectTags,
                outputFormat,
                fileName,
                startDate,
                endDate,
            };
        },

        loadExport() {
            if (
                this.formValues.savedExport &&
                this.formValues.savedExport.id &&
                this.formValues.savedExport.text &&
                this.formValues.savedExport.query
            ) {
                const query = JSON.parse(this.formValues.savedExport.query);

                // Nom de l'export
                this.formValues.saveExportName = this.formValues.savedExport.text;

                // Export partagé
                if (this.formValues.savedExport.shared !== undefined) {
                    for (let i = 0; i < this.sharedExportList.length; i++) {
                        if (this.formValues.savedExport.shared == this.sharedExportList[i].id) {
                            this.formValues.sharedExport = this.sharedExportList[i];
                            break;
                        }
                    }
                }

                // Groupes d'objets
                if (query.objectGroup) {
                    for (let i = 0; i < this.objectGroupsList.length; i++) {
                        if (query.objectGroup == this.objectGroupsList[i].id) {
                            this.formValues.objectGroup = this.objectGroupsList[i];
                            break;
                        }
                    }
                }

                // Statuts
                this.formValues.objectStatus = [];
                if (query.objectStatus) {
                    for (let i = 0; i < this.objectStatusList.length; i++) {
                        if (query.objectStatus.indexOf(this.objectStatusList[i].id) !== -1) {
                            this.formValues.objectStatus.push(this.objectStatusList[i]);
                        }
                    }
                }

                // États
                this.formValues.objectStates = [];
                if (query.objectStates) {
                    for (let i = 0; i < this.objectStatesList.length; i++) {
                        if (query.objectStates.indexOf(this.objectStatesList[i].id) !== -1) {
                            this.formValues.objectStates.push(this.objectStatesList[i]);
                        }
                    }
                }

                // Tags
                this.formValues.objectTags = [];
                if (query.objectTags) {
                    for (let i = 0; i < this.objectTagsList.length; i++) {
                        if (query.objectTags.indexOf(this.objectTagsList[i].id) !== -1) {
                            this.formValues.objectTags.push(this.objectTagsList[i]);
                        }
                    }
                }

                // Groupes d'objets
                if (query.outputFormat) {
                    for (let i = 0; i < this.outputFormatsList.length; i++) {
                        if (query.outputFormat == this.outputFormatsList[i].id) {
                            this.formValues.outputFormat = this.outputFormatsList[i];
                            break;
                        }
                    }
                }

                // Date de début
                if (query.startDate) {
                    const startDate = new Date(query.startDate);
                    if (startDate.getTime()) {
                        this.formValues.startDate = startDate;
                    }
                }

                // Date de fin
                if (query.endDate) {
                    const endDate = new Date(query.endDate);
                    if (endDate.getTime()) {
                        this.formValues.endDate = endDate;
                    }
                }
            }
        },
        removeExport() {
            const exportId = this.formValues.savedExport.id;
            if (exportId) {
                //this.isLoading = true;
                this.$http.delete(`/api/export/saved/${exportId}`).then(
                    () => {
                        // Recharge la liste des exports
                        this.loadSavedExportsList();
                        // Vide la valeur en cours dans la liste
                        this.formValues.savedExport = {};
                        //this.isLoading = false;
                    },
                    (response) => {
                        //this.isLoading = false;
                        // Error
                        console.error(response.data);
                    },
                );
            }
        },
        downloadExport(key, name) {
            //this.isLoading = true;
            const exportedFileUrl = `api/export/download/${key}/${name}`;
            this.$http({
                url: exportedFileUrl,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.body]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', name);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
            //this.isLoading = false;
        },
    },
    components: {
        LoadingDots,
        Input,
        Select,
        ConfigLink,
        Datepicker,
        MenuLink,
    },
    computed: {},
};
</script>

<style lang="scss">
$menu-width: 240px;

#export-view {
    display: flex;
    flex-direction: row;

    .export-body {
        margin: 25px 30px;
        padding: 20px 0;
        border: 1px solid #9ca5b0;
        border-radius: 5px;
        border-top: 5px solid #6c3e91;
        background-color: #ffffff;

        .export-section {
            width: 75%;
            h3.section--title {
                // margin-left: 35px;
                margin: 5px 35px 20px;
                padding-bottom: 5px;
                font-size: 2em;
                font-weight: 600;
                text-transform: uppercase;
                border-bottom: 3px solid black;
            }
            h4.subsection--title {
                margin: 5px 35px 20px;
                padding-top: 5px;
                padding-bottom: 5px;
                font-size: 1.5em;
                font-weight: 400;
                border-bottom: 1.5px solid grey;
            }
        }

        .mt-5 {
            margin-top: 5em;
        }

        .sm-field {
            max-width: 800px;
        }
    }
    .export-content {
        width: 100vw;
        height: 100vh;
        background-color: #f8f8f8;
        overflow: scroll;
        min-width: 724px;
    }

    .export-menu {
        width: $menu-width;
        background-color: #ffffff;
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;

        .logo {
            width: $menu-width;
            height: 50px;
            background-color: #6c3e91;
            flex-shrink: 0;
            flex-grow: 0;
            flex-basis: 50px;

            display: flex;
            flex-direction: column;
            justify-content: center;

            > img {
                margin-left: 20px;
                display: block;
                max-width: 115px;
                height: auto;
            }
        }

        .config {
            flex-shrink: 0;
            flex-grow: 0;
            display: flex;
            flex-direction: column;
        }
    }
}

.title {
    color: #151b25;
    margin: 20px 30px;
    font-size: 22px;
    font-weight: 600;
    line-height: 30px;
}

.export-title {
    padding: 14px 48px;
    color: #2a2a2a;
    font-size: 19px;
    font-weight: 600;
    line-height: 26px;
    text-align: center;
    width: 100%;
}

.export-date-range {
    width: 100%;
    height: 58px;
    margin-top: 10px;

    .export-date-start {
        float: left;
        width: calc(50% - 5px);
        padding-right: 5px;
    }
    .export-date-end {
        float: right;
        float: right;
        width: calc(50% - 5px);
        padding-left: 5px;
    }
    .vdp-datepicker {
        padding: 10px 15px;
        border: 1px solid #8e919b;
        border-radius: 32px;

        align-items: center;

        input {
            width: 100%;
            color: #3b3e47;
            background-color: transparent;
            border: none;
        }
    }
}
.export-button {
    margin-top: 25px;
    text-align: center;
}

.osm-button {
    cursor: pointer;
}

.osm-button.warning,
.osm-button.warning:focus {
    background-color: orange;
}

.osm-button.danger,
.osm-button.danger:focus {
    background-color: red;
}

.dropdown {
    cursor: pointer;
}
</style>
